export const environment = {
  production: false,
  apiUrl: 'https://featureapi-dexor.demo-crypto.com/api',
  contracts: {
    11155111: {
      SWAP_ROUTER: '0x25D845fa893C0a0137f27A955686d99A2C931154',
      POSITION_MANAGER: '0xdDCb4c5D6FB46163E63e281A976F7fA0C61b5170',
      QUOTER_V2: '0xcbd1A83DbFBbe812C908C84d438a4df42Cc7F486',
      DEXOR_EXTERNAL_LIQUIDITY_ROUTER: '0x38A942b955629071939d0c8e051924d0BbB358b8',
      FARMING: '0xF7E2cf41a5BB7c542B3e364d8d9b609813FF00da',
      FACTORY: '0x0f7b24309366F4a5754CB158b7b77577895eDD86',
      MASTER_STAKING: '0x79852246b4b4d9352d8eF2dD59FbdC0019910822',
      EXTERNAL_MANAGERS: {
        Uniswap: '0xC36442b4a4522E871399CD717aBDD847Ab11FE88',
        PancakeSwap: '0x46A15B0b27311cedF172AB29E4f4766fbE7F4364',
      },
      TOKENS: {
        DXOR: '0xC6EbB3b453E189E269B0D20a85Fae8C98b74c8e9',
        TOKEN_A: '0x0329bde48d7b2a1786d3a4b209ecf906091cc511',
        TOKEN_B: '0x9AbE3A30FEE8cC2c910255bFab52876d5059366d',
      },
    },
    97: {
      SWAP_ROUTER: '0x3843186978e58FF6f0853a76374c692645E4e4eF',
      POSITION_MANAGER: '0xC0d92A24A114d53Cd8D452fB5102cC4CBA20f47A',
      QUOTER_V2: '0x9C7AC917063C1C48575faeAa611e4391911Be79C',
      DEXOR_EXTERNAL_LIQUIDITY_ROUTER: '0x38A942b955629071939d0c8e051924d0BbB358b8',
      FARMING: '0x336f5b4E803a48470DFF1079ed67fF5919Abd401',
      // FARMING: '0x4cb1837ea6Dc800CBf20C45cdC83988A1b7D850A',
      TOKENS: {
        DXOR: '0xC6EbB3b453E189E269B0D20a85Fae8C98b74c8e9',
        TOKEN_A: '0x0329bde48d7b2a1786d3a4b209ecf906091cc511', // Placeholder
        TOKEN_B: '0x9AbE3A30FEE8cC2c910255bFab52876d5059366d', // Placeholder
      },
    },
    1: {
      SWAP_ROUTER: '0xE592427A0AEce92De3Edee1F18E0157C05861564',
      POSITION_MANAGER: '0x7EF7E3Cf89b89554Dc586FA7fE2A11230714cA9A',
      QUOTER_V2: '0x61fFE014bA17989E743c5F6cB21bF9697530B21e',
      DEXOR_EXTERNAL_LIQUIDITY_ROUTER: '',
      FARMING: '0xF29389F62358293764e36fe63F335b57bDe0401F',
      TOKENS: {
        DXOR: '0xefBeAbCdaC648bC2b3b7e0726c56348afA2C64b2',
        TOKEN_A: '',
        TOKEN_B: '',
      },
    },
    137: {
      SWAP_ROUTER: '',
      POSITION_MANAGER: '',
      QUOTER_V2: '',
      DEXOR_EXTERNAL_LIQUIDITY_ROUTER: '0x65b175F7538b6e8bfE7081F5085A1417AdCDc53E',
      FARMING: '',
      EXTERNAL_MANAGERS: {
        Uniswap: '0xC36442b4a4522E871399CD717aBDD847Ab11FE88',
        PancakeSwap: '0x46A15B0b27311cedF172AB29E4f4766fbE7F4364',
      },
      TOKENS: {
        DXOR: '',
        TOKEN_A: '',
        TOKEN_B: '',
      },
    },
  },
  coinGeckoApiUrl: 'https://api.coingecko.com/api/v3',
  rpcUrls: {
    1: 'https://eth.drpc.org',
    56: 'https://bsc-dataseed.binance.org',
    137: 'https://polygon-bor-rpc.publicnode.com',
    11155111: 'https://ethereum-sepolia-rpc.publicnode.com',
    80002: 'https://rpc-amoy.polygon.technology',
    97: 'https://data-seed-prebsc-1-s1.binance.org:8545',
  },
  subgraphs: {
    1: {
      Uniswap: 'https://gateway.thegraph.com/api/c90ce304d03b7ca57fd347420e620c79/subgraphs/id/5zvR82QoaXYFyDEKLZ9t6v9adGNptxYpKpSbxtgVENFV',
      PancakeSwap: 'https://gateway.thegraph.com/api/c90ce304d03b7ca57fd347420e620c79/subgraphs/id/9opY17WnEPD4REcC43yHycQthSeUMQE26wyoeMjZTLEx',
    },
    11155111: {
      Uniswap: 'https://api.studio.thegraph.com/query/4540/uniswap-v3-sepolia/version/latest',
      PancakeSwap: 'https://gateway.thegraph.com/api/c90ce304d03b7ca57fd347420e620c79/subgraphs/id/9opY17WnEPD4REcC43yHycQthSeUMQE26wyoeMjZTLEx',
    },
    56: {
      Uniswap: 'https://gateway.thegraph.com/api/c90ce304d03b7ca57fd347420e620c79/subgraphs/id/7XgdLW3bts4HktCYsu9dy8bEnuiNeZuftcuK3Aj4JXYV',
      PancakeSwap: 'https://gateway.thegraph.com/api/c90ce304d03b7ca57fd347420e620c79/subgraphs/id/ChmxqA9bX71cB2cQTRRULbWUBKoMRk7oh3JnpZShDQ2V',
    },
    137: {
      Uniswap: 'https://gateway.thegraph.com/api/c90ce304d03b7ca57fd347420e620c79/subgraphs/id/BvYimJ6vCLkk63oWZy7WB5cVDTVVMugUAF35RAUZpQXE',
      PancakeSwap: 'https://api.thegraph.com/subgraphs/name/pancakeswap/exchange-v3-polygon',
    },
  },
  networkMode: 'TESTNET',
  networks: {
    internal: {
      id: 'sepolia',
      chainId: 11155111,
      apiNetwork: 'SEPOLIA',
      zeroXPrefix: 'sepolia:',
    },
    external: {
      id: 'amoy',
      chainId: 80002,
      apiNetwork: 'AMOY',
      zeroXPrefix: 'amoy:',
    },
  },
};
